import { useState } from 'react';
import { Button, Alert, Spinner } from 'reactstrap';
import ReactDOM from 'react-dom'

let quest = {
    q: '',
    incAns: [],
    corrAns: ''
};

console.log(quest);
function Questions(props) {
    fetchQuestion();
    let [incorrectStreak, uIncorrectStreak] = useState(1)
    let [questionAnswered, uQuestionAnswered] = useState(false);
    let [questionUpdated, uQuestionUpdated] = useState(false);
    let answerButtons = quest.incAns.map(ans => {
        return <Button key={ans} className='btn' onClick={onWrong} color='warning'>{ans} </Button>
    });
    answerButtons.push(<Button key={quest.corrAns} className='btn' onClick={onCorrect} color='warning'>{quest.corrAns}</Button>);
    answerButtons = shuffleArray(answerButtons);
    function getNewQuestion() {
        uQuestionUpdated(false);
        fetchQuestion();
        console.log(quest);
    }

    function onCorrect() {
        props.streakGain();
        uIncorrectStreak(1);
        let div = document.getElementById('container1');
        let alert = (<Alert color='success' fade={true}>
            <h2>Your Answer Was Correct!</h2>
            <p>Keep up the streak!</p>
        </Alert>)
        ReactDOM.render(alert, div)
        uQuestionAnswered(true);
    }

    function onWrong() {
        props.streakLose();
        uIncorrectStreak(incorrectStreak + 1);
        let div = document.getElementById('container1');
        let alert = (
            <Alert color='danger' fade={true}>
                <h2>Your Answer Was Incorrect</h2>
                <p>Back To 0 You Go! You have gotten {incorrectStreak} wrong in a row!</p>
            </Alert>
        )
        ReactDOM.render(alert, div)
        uQuestionAnswered(true);
    }

    function fetchQuestion() {
        fetch('https://opentdb.com/api.php?amount=1&encode=url3986', {
            method: 'GET'
        })
            .then(reponse => {
                let data = reponse.json();
                return data;
            })
            .then(data => {
                quest.q = ''
                quest.q = stringFixer(decodeURI(data.results[0].question));
                quest.incAns = []
                for (let i = 0; i < data.results[0].incorrect_answers.length; i++) {
                    quest.incAns.push(stringFixer(decodeURI(data.results[0].incorrect_answers[i])));
                }
                quest.corrAns = '';
                quest.corrAns = stringFixer(decodeURI(data.results[0].correct_answer));
            })
            .then(() => {
                uQuestionUpdated(true);
            })
            .then(() => {
                uQuestionAnswered(false);
            })
            .catch(err => {
                console.log(err);
            });

    }

    if (!questionAnswered && questionUpdated) {
        return (
            <div>
                <h2>{quest.q}</h2>
                <div>
                    {answerButtons}
                </div>
            </div>
        );
    } else if (questionAnswered && !questionUpdated) {
        return (
            <div>
                <Button onClick={getNewQuestion}>Go Again!</Button>
            </div>
        );
    } else {
        return (
            <div>
                <Spinner color="primary">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        );
    }
}


function stringFixer(str) {
    if (str.includes('%3F')) {
        str = str.replace('%3F', '?');
    }
    if (str.includes('%3A')) {
        str = str.replace('%3A', '-');
    }
    if (str.includes('%2C')) {
        str = str.replace('%2C', ',');
    }
    if (str.includes('%3B')) {
        str = str.replace('%3B', ';');
    }
    if (str.includes('%3A')) {
        str = str.replace('%3A', ':');
    }
    if (str.includes('%2B')) {
        str = str.replace('%2B', '+');
    }
    if (str.includes('%2F')) {
        str = str.replace('%2F', '/');
    }
    if (str.includes('%26')) {
        str = str.replace('%26', '&');
    }
    if (str.includes('%24')) {
        str = str.replace('%24', '$');
    }
    if (str.includes('%25')) {
        str = str.replace('%25', '%');
    }
    if (str.includes('%21')) {
        str = str.replace('%21', '!');
    }
    if (str.includes('%28')) {
        str = str.replace('%28', '(');
    }
    if (str.includes('%29')) {
        str = str.replace('%29', ')');
    }
    if (str.includes('%2A')) {
        str = str.replace('%2A', '*');
    }
    return str
}

function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
    return array;
}

export default Questions;